module.exports = __webpack_public_path__ + "394a46b41d295dd653d2b0c7079538b6.webp";